import React from 'react';
import classNames from 'classnames';
import { Translate } from 'react-localize-redux';
import sidebarCss from '../signup/sidebar.css';
import wizardCss from './style.css';
import SingularLogoIcon from '../resources/svg/singular_logo_blue_figma.svg';
import PartnerCheckIcon from '../resources/svg/partner_check_icon.svg';
import G2Logo from '../resources/svg/g2_logo.svg';
import G2Stars from '../resources/svg/g2_stars.svg';
import G2BestResults from '../resources/svg/g2_best_results.svg';
import G2BestRelationship from '../resources/svg/g2_best_relationship.svg';
import { TRANSLATE_PREFIX } from './consts';

const SIDEBAR_BENEFITS = [
    `${TRANSLATE_PREFIX}.SIDEBAR_BENEFIT_1`,
    `${TRANSLATE_PREFIX}.SIDEBAR_BENEFIT_2`,
    `${TRANSLATE_PREFIX}.SIDEBAR_BENEFIT_3`,
    `${TRANSLATE_PREFIX}.SIDEBAR_BENEFIT_4`,
];

export default function WizardSidebar() {
    return (
        <div className={classNames(sidebarCss.partnerSidebar, wizardCss.partnerSidebar)}>
            <div className={classNames(sidebarCss.sidebarContent, wizardCss.sidebarContent)}>
                <div className={classNames(sidebarCss.sidebarHeader, wizardCss.sidebarHeader)}>
                    <SingularLogoIcon className={sidebarCss.sidebarLogo} />
                    <div className={sidebarCss.sidebarTitle}>
                        <Translate id={`${TRANSLATE_PREFIX}.SIDEBAR_TITLE`} />
                    </div>
                    <div className={sidebarCss.sidebarDescription}>
                        <Translate id={`${TRANSLATE_PREFIX}.SIDEBAR_DESCRIPTION`} />
                    </div>
                </div>
                <div className={sidebarCss.sidebarBenefitsSection}>
                    <div className={classNames(sidebarCss.sidebarSectionTitle, wizardCss.sidebarSectionTitle)}>
                        <Translate id={`${TRANSLATE_PREFIX}.SIDEBAR_WHY_TITLE`} />
                    </div>
                    <div className={sidebarCss.sidebarBenefitsList}>
                        {SIDEBAR_BENEFITS.map(benefitKey => (
                            <div key={benefitKey} className={sidebarCss.sidebarBenefitItem}>
                                <PartnerCheckIcon className={sidebarCss.sidebarBenefitIcon} />
                                <div className={sidebarCss.sidebarBenefitText}>
                                    <Translate id={benefitKey} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className={classNames(sidebarCss.sidebarFooter, wizardCss.sidebarFooter)}>
                <div className={sidebarCss.sidebarFooterSeparator} />
                <div className={classNames(sidebarCss.sidebarFooterTitle, wizardCss.sidebarFooterTitle)}>
                    <Translate id={`${TRANSLATE_PREFIX}.SIDEBAR_FOOTER`} />
                </div>
                <div className={sidebarCss.sidebarBadges}>
                    <div>
                        <G2Logo className={sidebarCss.sidebarG2Logo} />
                        <G2Stars className={sidebarCss.sidebarG2Stars} />
                    </div>
                    <G2BestResults className={sidebarCss.sidebarBadge} />
                    <G2BestRelationship className={sidebarCss.sidebarBadge} />
                </div>
            </div>
        </div>
    );
}
